export default __webpack_public_path__ + "static/IMG_5529-2602a77712ca7acf0d45c124679282b5.jpeg";